import { render, staticRenderFns } from "./HistoricoCampanhas.vue?vue&type=template&id=07eb162f&scoped=true"
import script from "./HistoricoCampanhas.vue?vue&type=script&lang=js"
export * from "./HistoricoCampanhas.vue?vue&type=script&lang=js"
import style0 from "./HistoricoCampanhas.vue?vue&type=style&index=0&id=07eb162f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eb162f",
  null
  
)

export default component.exports